module.exports = __webpack_public_path__ + "static/media/PriceList.115aa73a.jpg";